let globalWidgets = {};
export const registerPopUpWidget = function (name, component) {
    globalWidgets[name] = component;
};

export const globalPopUpWidget = function (name, content) {
    if (globalWidgets[name] && globalWidgets[name].displayContent) {
        globalWidgets[name].displayContent(content);
    } else {
        alert('PopUp widget ' + name + ' not available');
    }
};


// WEBPACK FOOTER //
// ./src/cms/PopUpDialogController.js